<template>
  <v-container fluid class="Subscription h-100 overflow-y-hidden">
    <v-row :class="{'h-100': $vuetify.display.mdAndUp}">
      <v-col cols="12" md="3" xl="2" class="bg-white">
        <SubscriptionMenu/>
      </v-col>
      <v-col md="9" xl="10" class="pa-2">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import { GET_SUBSCRIPTION } from '@/store/modules/subscription/action_types'
import SubscriptionMenu from '@/subscriptions/SubscriptionMenu.vue'

export default {
  name: 'Subscription',
  components: { SubscriptionMenu },
  computed: {
    ...mapState('user', ['profile']),
    ...mapState('subscription', ['subscription']),
    ...mapGetters('user', ['canAccessSubscription']),
  },
  created () {
    if (!this.canAccessSubscription) {
      this.$router.replace('/')
    }
    this.prepareGetSubscription()
  },
  methods: {
    ...mapActions('subscription', [GET_SUBSCRIPTION]),
    prepareGetSubscription () {
      this.GET_SUBSCRIPTION(this.profile.subscription.id)
    },
  },
}
</script>

<style lang="scss">
  .Subscription {
    .v-data-table__td-value {
      .td-mobile-view {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
</style>
